import { pxChangeVw } from "@/utils";
import { _css } from "@/utils/dom";
import { setCssVar } from "@/utils/setCssVar";
import { applyGooglePublisherTagPageConfig } from "@/components/common/GooglePublisherTag/pageLevelConfig";
import { shouldPauseMqsGoogleAdRequest, useMqsInterstitialGateSnapshot } from "./mqsInterstitialGate";
export default function Anchor1(props: any) {
  let { slot: slot1, dataPosition } = props;
  const { hostName } = useHostName();
  const mqsInterstitialGate = useMqsInterstitialGateSnapshot();
  const shouldPauseForMqsInterstitial = shouldPauseMqsGoogleAdRequest(
    hostName,
    mqsInterstitialGate.suppressDisplayRequests,
  );
  useAdBodyClass(props.type, dataPosition);
  const [isMounted, setIsMounted] = useState(false);
  useEffect(() => {
    setIsMounted(true);
    return () => {
      setIsMounted(false);
    };
  }, []);
  let slotObj: any = null;
  useEffect(() => {
    if (!isMounted || shouldPauseForMqsInterstitial) return;
    // m-qs 第二轮插屏正在展示时，先不要重新请求底部锚定广告；
    // ready 缓存态继续允许普通广告请求，避免新页面只剩占位。
    setCssVar({
      key: "--privacy-policy-padding-bottom",
      value: `120px`,
    });
    console.log("slot1", slot1);
    window.googletag = window.googletag || { cmd: [] };
    googletag.cmd.push(function () {
      slotObj = googletag.defineOutOfPageSlot(slot1, googletag.enums.OutOfPageFormat["BOTTOM_ANCHOR"]);
      if (slotObj) slotObj.addService(googletag.pubads());
      applyGooglePublisherTagPageConfig();
      googletag.enableServices();
      googletag.display(slotObj);
      window.googletag.pubads().addEventListener("slotRenderEnded", (event: any) => {
        if (event.slot.getSlotId().getName() === slot1) {
          let hasAdDisplayed = false;
          let retryCount = 0;

          const checkAdDisplay = () => {
            if (hasAdDisplayed) {
              return;
            }
            const timer = setTimeout(() => {
              const displayedAds = document.querySelectorAll('ins[data-anchor-status="displayed"]');
              if (displayedAds.length) {
                hasAdDisplayed = true;
                setCssVar({
                  key: "--privacy-policy-padding-bottom",
                  value: `${(displayedAds?.[0]?.clientHeight ?? 100) + 30 + 25}px`,
                });
                return;
              }
              clearTimeout(timer);
              retryCount++;
              if (retryCount >= 10) {
                hasAdDisplayed = true;
              }
              checkAdDisplay();
            }, 300);
          };
          checkAdDisplay();
        }
      });
    });
    return () => {
      setCssVar({
        key: "--privacy-policy-padding-bottom",
        value: pxChangeVw(`30px`),
      });
      googletag?.destroySlots?.([slotObj]);
    };
  }, [isMounted, shouldPauseForMqsInterstitial]);

  return <div className="fixed left-2000 bottom-0">{slot1}</div>;
}
